import Vue from 'vue'
import Vuex from 'vuex'
// import api from '../utils/api'
import * as actions from './actions'
import { NEWER_TASK, DAY_TASK, SPECIAL_TASK, VIP_TASK } from '@/utils/constant'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isNoneCashVer: false, // 是否是特殊版本，不支持现金任务
    userInfo: {},
    devicesInfo: {},
    isMGTV: false,
    ifLogin: false,
    conf: {},
    versionType: 0, //ABTest 1A 0B
    taskInfo: {}, //任务数据
    cashUserInfo: {},
    isIphoneXRS: false,
    notices: [], // 公告栏数据
    bindPhone: false, // 绑定手机号任务的标志位
    showState: '000', // 开关状态，参见此文档 https://wiki.imgo.tv/pages/viewpage.action?pageId=5343185 3.9节
  },
  mutations: {
    setIsSpecialVersion(state, isNoneCashVer) {
      state.isNoneCashVer = isNoneCashVer
    },
    setBindPhone(state, bindPhone) {
      state.bindPhone = bindPhone
    },
    setNotices(state, notices) {
      state.notices = notices
    },
    setIsIphoneXRS(state, isIphoneXRS) {
      state.isIphoneXRS = isIphoneXRS
    },
    setCashUserInfo(state, cashUserInfo) {
      state.cashUserInfo = cashUserInfo
    },
    setUserInfo(state, newUserInfo) {
      state.userInfo = newUserInfo
    },
    setDevicesInfo(state, newDevicesInfo) {
      state.devicesInfo = newDevicesInfo
    },
    setIsMGTV(state, currentIsMGTV) {
      state.isMGTV = currentIsMGTV
    },
    setIfLogin(state, newIfLogin) {
      state.ifLogin = newIfLogin
    },
    setConf(state, newConf) {
      state.conf = newConf
    },
    setVersionType(state, newVersionType) {
      state.versionType = newVersionType
    },
    setTaskInfo(state, newTaskInfo) {
      state.taskInfo = newTaskInfo
    },
    switchSignRemind(state) {
      state.taskInfo.remainStatus = -state.taskInfo.remainStatus
    },
    switchSecKillRemind(state) {
      state.taskInfo.secKillRemainStatus =
        state.taskInfo.secKillRemainStatus == 1 ? 0 : 1
    },
    setShowState(state, showState) {
      state.showState = showState
    },
  },
  actions,
  getters: {
    isLogin(state) {
      return state.userInfo && Object.keys(state.userInfo).length > 0
    },

    list(state) {
      const taskInfo = state.taskInfo
      if (!taskInfo) return []
      return handleList(taskInfo)
    },

    canGetList(state) {
      // const taskInfo = state.taskInfo
      // if (!taskInfo) return []
      // const list = []
      // Object.keys(taskInfo).forEach(key => {
      //   if (
      //     (NEWER_TASK.includes(+key) ||
      //       DAY_TASK.includes(+key) ||
      //       SPECIAL_TASK.includes(+key)) &&
      //     taskInfo[key].status === 1
      //   ) {
      //     list.push(handleTask(key, taskInfo[key]))
      //   }
      // })

      const taskInfo = state.taskInfo
      if (!taskInfo) return []
      let list = handleList(taskInfo)

      if (!list || !list.length) return []
      const ret = []
      list.forEach((item) => {
        const temp = item.list.filter((v) => v.status === 1)
        temp && temp.length && ret.push(...temp)
      })
      return ret
    },

    // 任务是非可领取状态的任务
    notCanGetList(state) {
      const taskInfo = state.taskInfo
      if (!taskInfo) return []
      let list = handleList(taskInfo)

      if (!list || !list.length) return []
      const ret = []
      list.forEach((item) => {
        const temp = item.list.filter((v) => v.status !== 1)
        temp && temp.length && ret.push(...temp)
      })
      return ret
    },
    // 积分签到弹窗是否显示
    isCreditModalShow: (state) => !Number(state.showState.charAt(0)),
    // 积分签到入口是否显示
    isCreditEntryShow: (state) => !Number(state.showState.charAt(1)),
    // 金刚位栏目是否显示
    isCreditNavShow: (state) => !Number(state.showState.charAt(2)),
  },
  modules: {},
})

/**
 * 转换任务
 * @param {*} key
 * @param {*} item
 */
function handleTask(key, item) {
  return {
    taskId: key,
    title: item.name,
    status: item.status,
    desc: item.desc,
    url: item.url,
    curStep: item.curStep,
    maxStep: item.maxStep,
    credits: item.credits,
    remainCredits: item.remainCredits || 0,
  }
}

function adjustSort(obj, task) {
  let list = []
  task.forEach((key) => {
    list.push(...obj.list.filter((v) => v.taskId == key))
  })

  const done = list.filter((v) => v.status === 2)
  const getted = list.filter((v) => v.status === 1)
  let notDo = list.filter((v) => v.status === 0)

  obj.list = [...getted, ...notDo, ...done]
  return obj
}

function handleList(taskInfo) {
  const list = []
  const newTasks = { name: '新手任务', list: [] }
  const dayTasks = { name: '今日任务', list: [] }
  const specialTasks = { name: '探索任务', list: [] }
  const vipTasks = { name: '其他任务', list: [] }
  Object.keys(taskInfo).forEach((key) => {
    if (isNaN(key)) return

    NEWER_TASK.includes(+key) &&
      newTasks.list.push(handleTask(key, taskInfo[key]))

    DAY_TASK.includes(+key) &&
      dayTasks.list.push(handleTask(key, taskInfo[key]))

    SPECIAL_TASK.includes(+key) &&
      specialTasks.list.push(handleTask(key, taskInfo[key]))

    VIP_TASK.includes(+key) &&
      vipTasks.list.push(handleTask(key, taskInfo[key]))
  })

  newTasks.list.length > 0 && list.push(adjustSort(newTasks, NEWER_TASK))

  const dayList = adjustSort(dayTasks, DAY_TASK)
  dayTasks.list.length > 0 && list.push(sortCard(dayList))

  specialTasks.list.length > 0 &&
    list.push(adjustSort(specialTasks, SPECIAL_TASK))

  vipTasks.list.length > 0 && list.push(adjustSort(vipTasks, VIP_TASK))

  return list
}

function sortCard(dayList) {
  const cardTask = dayList.list.filter((item)=>item.taskId == 31)[0]
  if (cardTask?.status === 0) {
    dayList.list = dayList.list.sort((a,b)=>{
      return a.taskId == 31 ? -1 : 1
    })
  }
  return dayList
}
